import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, SHOP_BY_CUSTOM_CATEGORIES } from '../../../Constants/Config';

const initialState = {
  loading: false,
  shopCustomCategoryList: [],
  error: '',
  totalPages: 0,
  hasMore: true,
};

export const fetchShopByCustomCategoriesLists = createAsyncThunk(
  'shopCustomCategoryList/fetchShopByCustomCategoriesLists',
  async ({ lat, long }, { rejectWithValue }) => {
    try {
      const formData = new FormData();

        formData.append('lat', lat || '');
      formData.append('long', long || '');
      const response = await axios.post(
        `${BASE_URL_SANDBOX}${SHOP_BY_CUSTOM_CATEGORIES}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status === 200 && response.data && response.data.data) {
        return {
          shopCustomCategoryList: response.data.data,
          totalPages: response?.data?.totalPages,
        };
      } else {
        return { shopCustomCategoryList: [], totalPages: 0, hasMore: false };
      }
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

const shopByCustomCategorySlice = createSlice({
  name: 'shopCustomCategoryList',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchShopByCustomCategoriesLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShopByCustomCategoriesLists.fulfilled, (state, action) => {
        state.loading = false;
        state.shopCustomCategoryList = action.payload?.shopCustomCategoryList;
        state.totalPages = action.payload?.totalPages || 0;
        state.error = '';
      })
      .addCase(fetchShopByCustomCategoriesLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch  Shop by Best Sellers Near You';
        state.hasMore = false;
      });
  },
});

export default shopByCustomCategorySlice.reducer;